import {AfterViewInit, Component, Input, ViewChild} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DsPdfViewer, ViewerOptions} from "@mescius/dspdfviewer";
import {config} from "@alpha/services/";
import {Helpers} from "../helpers";

@Component({
  selector: 'pdf-preview',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './pdf-preview.component.html',
  styleUrls: ['./pdf-preview.component.scss']
})
export class PdfPreviewComponent implements AfterViewInit {

  @ViewChild("preview") preview: HTMLElement | undefined;
  @Input() options: ViewerOptions | undefined;

  viewer: DsPdfViewer | undefined;
  loading: boolean = false;

  constructor() {
  }

  ngAfterViewInit() {

    if (!this.options) {
      this.options ??= new ViewerOptions();
      this.options.ignoreInitialView = true;
      this.options.restoreViewStateOnLoad = true;
      this.options.buttons = ["custom-fullscreen", "custom-download", "print", "$navigation", "zoom", "pan", "text-selection", "view-mode", "rotate"];
      this.options.requireTheme = 'viewer';
      this.options.renderer = 'canvas';
    }

    DsPdfViewer.LicenseKey = atob(config.gc);
    this.init();
  }

  init() {
    this.viewer = new DsPdfViewer("#preview", this.options);
    this.viewer.addThumbnailsPanel();
    this.viewer.addSearchPanel();
    this.viewer.options.zoomByMouseWheel = {always: false, ctrlKey: true, metaKey: true};
    this.viewer.options.shortcuts = {
      82: [{
        ctrl: true, keyCode: 82, tool: () => {
        }
      }]
    }

    const React = this.viewer.getType("React");

    const viewer: any = this.viewer;
    const toolbar = viewer.toolbar;

    this.viewer.onAfterOpen.register(() => {
      if (document.querySelector('#preview:has(.gcv-main-view.gcv-main-view--fullscreen)')) {
        viewer.toolbar._view._commands.toggleFullscreen();
      }
    });

    toolbar.addItem({
      key: "custom-fullscreen",
      icon: {
        type: 'svg',
        content: React.createElement(
          'svg',
          {
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            width: '24',
            height: '24',
            viewBox: '0 0 24 24',
            fill: '#559765'
          },
          React.createElement('path', {d: 'M5,5H10V7H7V10H5V5M14,5H19V10H17V7H14V5M17,14H19V19H14V17H17V14M10,17V19H5V14H7V17H10Z'})
        )
      },
      title: "Fullscreen",
      enabled: true,
      action: async () => {
        viewer.toolbar._view._commands.toggleFullscreen();
        window.dispatchEvent(new Event('resize'));
      },
    });
  }

  load(data: Uint8Array) {
    try {
      this.loading = true;
      this.viewer?.open(data).then(res => {
        this.loading = false;
      })
    } catch (e) {
      this.init()
      console.error(e)
      this.loading = false;
    }
  }
}
